import { render, staticRenderFns } from "./SolutionsSection.vue?vue&type=template&id=70f9075d&scoped=true"
import script from "./SolutionsSection.vue?vue&type=script&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&lang=js"
import style0 from "./SolutionsSection.vue?vue&type=style&index=0&id=70f9075d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9075d",
  null
  
)

export default component.exports